import { render, staticRenderFns } from "./SweetSpot.vue?vue&type=template&id=b4f90dba"
import script from "./SweetSpot.vue?vue&type=script&lang=js"
export * from "./SweetSpot.vue?vue&type=script&lang=js"
import style0 from "./SweetSpot.vue?vue&type=style&index=0&id=b4f90dba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports